// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"55":"Quiz","407":"process","459":"p404","535":"login"}[chunkId] || chunkId) + "." + {"55":"713bd650","407":"0291bc1b","459":"ec1f4e0c","535":"d452e03a","837":"2390900e"}[chunkId] + ".css";
};